import { wpPhone } from "../constants/appConstats";

export const openFooterWhatsApp = ({ languageId }) => {
  const message = [
    "Hello, I would like to know general information about a tour.",
    "Përshëndetje, do të doja të dija informacione të përgjithshme në lidhje me një pakete turistike.",
  ][languageId ?? 0];

  const url = `https://wa.me/${wpPhone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};

export const sendBookingToWhatsApp = (formData, packageTitle) => {
  const message = `
🧳 New Booking Request

   Package Title: ${packageTitle}
👤 Name: ${formData?.fullName}
📞 Phone: ${formData?.phone}
📧 Email: ${formData?.email}

📅 Date: ${new Date(formData?.date).toLocaleDateString()}
👥 Guests: ${formData?.guests}

📝 Special Request:
${formData?.specialRequest || "None"}
  `.trim();

  const url = `https://wa.me/${wpPhone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};

export const openFooterEmail = ({ languageId }) => {
  const email = "info@yourwebsite.com";

  const subject = [
    "Tour Information Request",
    "Kërkesë për Informacion Turistik",
  ][languageId ?? 0];

  const body = [
    "Hello, I would like to know general information about a tour.",
    "Përshëndetje, do të doja të dija informacione të përgjithshme në lidhje me një paketë turistike.",
  ][languageId ?? 0];

  const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;

  window.location.href = mailtoUrl;
};

export const openLocationInMaps = () => {
  const city = encodeURIComponent("Shkodër, Albania");

  const url = `https://www.google.com/maps/search/${city}`;

  window.open(url, "_blank");
};

export const sendFormToWhatsApp = (formData) => {
  const message = `
New Tour Request:

Name: ${formData?.name}
Email: ${formData?.email}
Subject: ${formData?.subject}

Message:
${formData?.message}
  `.trim();

  const url = `https://wa.me/${wpPhone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};

export const openInstagram = () => {
  window.open(
    "https://www.instagram.com/shkodertourguide?igsh=M3pxYWFheTViZmJi",
    "_blank",
    "noopener,noreferrer",
  );
};

export const openTikTok = () => {
  window.open(
    "https://www.tiktok.com/@shkodertourguide",
    "_blank",
    "noopener,noreferrer",
  );
};
